module.exports = __webpack_public_path__ + "pdf-file.1adef7766e1c10b66df8.svg";


//////////////////
// WEBPACK FOOTER
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/assets/images/pdf-file.svg
// module id = HEia
// module chunks = 0